















































import '@adyen/adyen-web/dist/adyen.css';

import AdyenCheckout from '@adyen/adyen-web';
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  useContext,
  useRouter,
  watch,
} from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';

import ErrorBar from '~/components/ErrorBar.vue';
import { useApi, useCart, useUiNotification } from '~/composables';
import { usePaymentStore } from '~/modules/checkout/stores/payment';

import { PlaceOrderGql } from '../composables/useMakeOrder/commands/adyenAppleGoogle.gql';
import { GetAdyenPayDetail } from '../composables/useMakeOrder/commands/adyenPay.gql';
import { AdyenOrder } from '../types';

export default defineComponent({
  name: 'AydenPayment',
  components: {
    ErrorBar,
  },
  props: {
    payMethod: {
      type: Object,
      default: () => {},
    },
    payDetail: {
      type: Object,
      default: () => {},
    },
    payLocale: {
      type: String,
      default: '',
    },
    paymentResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['finalplace'],
  setup(props, { emit }) {
    const { query } = useApi();
    const { cart } = useCart();
    const appleRef = ref(null); //  apple pay
    const router = useRouter();
    const { send: sendNotification } = useUiNotification();
    const isLoading = ref<Boolean>(false);
    const {
      app: {
        localeRoute,
        $vsf,
        i18n
      },
      $config: { adyenPayClientID },
    } = useContext();
    const apiState = $vsf.$magento.config.state;
    const order = ref<AdyenOrder>();
    const cardState = ref<any>();
    const valid = ref<Boolean>(false); // check if card is valid
    const paymentStore = usePaymentStore();
    const cartId = computed(() => cart.value.id ?? '');
    const {
      adyenPaymentDetails,
      loading: isPaying,
      error: paymentError,
    } = storeToRefs(paymentStore);
    const cardComponent = ref();
    const { payMethod, payDetail, payLocale, paymentResponse } = props;
    const isApplePay = computed(() => payMethod.type === 'applepay');
    console.log('**** isApplePay payMethod', isApplePay.value, payMethod);

    // ________________________________________________
    const handleServerResponse = (res, component) => {
      if (res.action) {
        console.log('*** Got Res Action ***:', JSON.parse(res.action));
        component.handleAction(JSON.parse(res.action));
      } else if (
        res.isFinal &&
        res.resultCode === ('Authorised' || 'Received' || 'PresentToShopper')
      ) {
        sendNotification({
          id: Symbol('adyen pay success'),
          message: i18n.t(
            'Congratualations! You have paid it successfully!'
          ) as string,
          persist: false,
          type: 'success',
          icon: 'check',
          title: 'Success!',
        });
        router.push(
          localeRoute({
            name: 'thank-you',
            query: {
              order: order.value.order_number,
            },
          })
        );
        // router.push(localePath('/checkout/success/thankyou'));
      }
    };
    const handleOnChange = (state: any, component: any) => {
      console.log('**** Adyen handleOnChange state:', state);
      valid.value = state.isValid;
      cardState.value = state.data;
      cardComponent.value = component;
    };

    const handlePlaceOrder = async (
      paymentMethod: string,
      cardDetails?: any
    ) => {
      if (paymentMethod) {
        isLoading.value = true;
        paymentStore.clearAdyenPayment('CLEAR_STATE');
        // const path = '/checkout/success/thankyou';
        const stateData = JSON.parse(cardDetails);
        const brandCode = stateData.paymentMethod.type;
        const paramsAdyen = {
          cart_id: cartId.value,
          brand_code: brandCode,
          // guestEmail: userEmail.value,
          code: 'adyen_hpp',
          // return_url: `https://${window.location.hostname}${path}`,
          stateData: cardDetails,
        };
        const { data, errors } = await query<any>(PlaceOrderGql, paramsAdyen);
        console.log('!!!!Adyen Pay Result:', data, errors);
        isLoading.value = false;
        if (errors && errors.length > 0) {
          console.log('** Adyen Place order error:', errors[0]);
          paymentStore.addPaymentDetailsError(errors[0]);
          sendNotification({
            id: Symbol('place_adyen_order_error'),
            message: errors[0].message as string,
            persist: false,
            type: 'danger',
            icon: 'check',
            title: 'Error!',
          });
          return;
        }
        // ---- **** success **** -----
        const { placeOrder } = data;
        order.value = placeOrder.order;
        paymentStore.addSelectedPayment(paymentMethod); // ayden_cc
        paymentStore.initAdyenPayment(true); // let state.loading = true;
        paymentStore.addPaymentDetails(order.value.adyen_payment_status);
      } else {
        sendNotification({
          id: Symbol('np_adyen_method_error'),
          message: i18n.t(
            'The payment method is missing, Select the payment method and try again!'
          ) as string,
          persist: false,
          type: 'danger',
          icon: 'check',
          title: 'Error!',
        });
      }
    };

    const onSubmit = (state: any) => {
      console.log('**** Adyen Apple-Google onSubmit state:', state);
      valid.value = state.isValid;
      cardState.value = state.data;
      const methodCodeStr = isApplePay.value ? 'applepay' : 'googlepay';
      handlePlaceOrder(methodCodeStr, JSON.stringify(state.data));
    };

    const handleAdditionalDetails = async (state: any, component: any) => {
      // -- update payment action --
      console.log('_handleAdditionalDetails', state.data);
      cardComponent.value = component;
      const paramData = state.data;
      const request = { ...paramData, orderId: order.value?.order_number };
      const param = {
        payload: JSON.stringify(request),
        cartId: cartId.value,
      };
      isLoading.value = true;
      const {
        data: { adyenPaymentDetails: adyenPaymentDetailsRes },
        errors,
      } = await query<any>(GetAdyenPayDetail, param);
      isLoading.value = false;
      if (errors && errors.length > 0) {
        console.log('** Get Adyen Pay Detail error:', errors[0]);
        paymentStore.addPaymentDetailsError(errors[0]);
        sendNotification({
          id: Symbol('adyen_payment_detail_error'),
          message: errors[0].message as string,
          persist: false,
          type: 'danger',
          icon: 'check',
          title: 'Error!',
        });
        return;
      }
      console.log(
        '*** handleAdditionalDetails result:',
        adyenPaymentDetailsRes
      );
      paymentStore.addPaymentDetails(adyenPaymentDetailsRes);
    };

    const initCheckout = async () => {
      console.log('***** init adyen pay ******:');
      const PayConfiguration = isApplePay.value
        ? {
          amount: payDetail.configuration.amount,
          countryCode:
              apiState.getLocale().toUpperCase() === 'MEX'
                ? 'MX'
                : apiState.getLocale().toUpperCase() ?? 'GB',
        }
        : {
          amount: payDetail.configuration.amount,
          countryCode:
              apiState.getLocale().toUpperCase() === 'MEX'
                ? 'MX'
                : apiState.getLocale().toUpperCase() ?? 'GB',
          // Set this to PRODUCTION when you're ready to accept live payments
          environment:
              process.env.NODE_ENV === 'development' ? 'TEST' : 'PRODUCTION',
          // environment: 'PRODUCTION',
          configuration: {
            ...payMethod.configuration,
            gateway: 'adyen',
            merchantName: 'Unineed Limited',
            gatewayMerchantId: 'UnineedLimitedCOM',
          },
          emailRequired: true,
          billingAddressRequired: false,
          // shippingAddressRequired: false, // https://developers.google.com/pay/api/web/reference/request-objects#ShippingAddressParameters
          onClick: (resolve, reject) => {
            console.log('***** Click the button now ****');
            emit('finalplace', isApplePay.value ? 'applepay' : 'googlepay');
            isLoading.value = true;
            resolve();
          },
          // onSubmit: (state) => {
          //   console.log('*** onSubmit data:', state);
          // }
        };
      console.log('** PayConfiguration:', PayConfiguration);
      try {
        const configuration: any = {
          locale: payLocale,
          // environment: 'live',
          environment: process.env.NODE_ENV === 'development' ? 'test' : 'live',
          showPayButton: true,
          clientKey:
            process.env.NODE_ENV === 'development'
              ? 'test_D3TRD24UIZGTHNFR2BQI5JFY744IMZMT'
              : adyenPayClientID,
          // clientKey: adyenPayClientID,
          analytics: {
            enabled: true, // Set to false to not send analytics data to Adyen.
          },
          paymentMethodsResponse: paymentResponse,
          onAdditionalDetails: handleAdditionalDetails, // Pass the updated callback function here
          onChange: handleOnChange,
          onSubmit,
          onError: (error, component) => {
            console.error(JSON.stringify(error));
            isLoading.value = false;
            if (error?.name === 'CANCEL') {
              error.message = 'Cancel Payment';
            }
            sendNotification({
              id: Symbol('adyen_payment_error'),
              message: error.message as string,
              persist: false,
              type: 'danger',
              icon: 'check',
              title: error.name,
            });
            paymentStore.addPaymentDetailsError(error);
          },
          onPaymentCompleted: (result, component) => {
            console.log(`** [onPaymentCompleted result: ${result}`);
            handleServerResponse(result, component);
          },
        };
        console.log('____ Payment Config_____');
        console.log(configuration);
        // if (isApplePay.value) {
        //   configuration.paymentMethodsResponse = paymentResponse;
        // }
        const checkout = await AdyenCheckout(configuration);
        // **** apple
        if (isApplePay.value) {
          const applePayComponent = checkout
            .create('applepay', PayConfiguration)
            .mount(appleRef.value);
          console.log('applePayComponent', applePayComponent);
        } else {
          const applePayComponent = checkout
            .create('googlepay', PayConfiguration)
            .mount(appleRef.value);
          console.log('googlePayComponent', applePayComponent);
        }
      } catch (error) {
        sendNotification({
          id: Symbol('adyen_payment_catch_error'),
          message: error.message as string,
          persist: false,
          type: 'danger',
          icon: 'check',
          title: 'Invalid data',
        });
        isLoading.value = false;
        console.error('Invalid data for payments', error);
      }
    };

    watch(adyenPaymentDetails, (newObj) => {
      if (order.value && order.value.order_number) {
        handleServerResponse(newObj, cardComponent.value);
      }
    });
    onMounted(() => {
      // todo
      setTimeout(() => {
        initCheckout();
      }, 400);
    });

    onUnmounted(() => {
      // todo
      paymentStore.addPaymentDetailsError(null);
      paymentStore.clearAdyenPayment('CLEAR_STATE');
    });
    return {
      // ...
      appleRef,
      isLoading,
      adyenPaymentDetails,
      paymentError,
      isPaying,
    };
  },
});
